module.exports = __webpack_public_path__ + "static/img/35.130f48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ADDomain/35.png
// module id = yfxm
// module chunks = 1